import AsoHeader from "../../../components/Aso/Header";
import AsoSelecionarResponsavel from "../../../components/Aso/Register/AsoSelecionarResponsavel";

const AsoRegistroSelecionarResponsavel = () => {
    return(
        <>
            <AsoHeader />
            <AsoSelecionarResponsavel />
        </>
    );
}

export default AsoRegistroSelecionarResponsavel;